import { Fragment } from "react/jsx-runtime";
import Button from "../../../../../components/form/Button";
import { useEffect } from "react";
import { useForm } from "react-hook-form";
import * as yup from "yup";
import { yupResolver } from "@hookform/resolvers/yup";
import { TabsComponentProps } from "../TabsComponent";
import { useCustomerProfile } from "../../../../Account/EditProfile/hooks/useProfile";

interface PhoneFormData {
  first_name: string;
  birth_date: string;
  gender: string;
  last_name: string;
  email?: string;
}

const ProfileForm = ({ customerInfo }: TabsComponentProps) => {
  const {
    editData,
    errorMessage,
    errorMessageText,
    successMessageText,
    successMessage,
  } = useCustomerProfile();
  const {
    register,
    handleSubmit,
    formState: { errors },
    setValue,
  } = useForm<PhoneFormData>({
    resolver: yupResolver(
      yup
        .object({
          first_name: yup.string().required("El nombre es requerido"),
          last_name: yup.string().required("El apellido es requerido"),
          birth_date: yup
            .string()
            .required("La fecha de nacimiento es requerida")
            .test("is-18", "Debes tener al menos 18 años", (value) => {
              if (!value) return false;
              const today = new Date();
              const birth = new Date(value);
              const age = today.getFullYear() - birth.getFullYear();
              const month = today.getMonth() - birth.getMonth();
              if (
                month < 0 ||
                (month === 0 && today.getDate() < birth.getDate())
              ) {
                return age - 1 >= 18;
              }
              return age >= 18;
            }),
          gender: yup.string().required("El género es requerido"),
        })
        .required()
    ),
    defaultValues: {
      first_name: "",
      last_name: "",
      birth_date: "",
      gender: "",
      email: "",
    },
  });

  const formatBirthDate = (dateStr: string) => {
  const [day, month, year] = dateStr.split("/");
  return `${year}-${month}-${day}`;
};

  useEffect(() => {
    if (customerInfo) {
      setValue("first_name", customerInfo.first_name || "");
      setValue("last_name", customerInfo.last_name || "");
       if (customerInfo.birth_date) {
      const formatted = formatBirthDate(customerInfo.birth_date);
      setValue("birth_date", formatted);
    }
      setValue("gender", customerInfo.gender || "");
      setValue("email", customerInfo.email || "");
    }
  }, [customerInfo, setValue]);

  const sendDataProfile = async (props: PhoneFormData) => {
    // Omitimos email usando destructuring
    const { email, ...cleanData } = props;

    console.log("Profile data submitted:", cleanData);

    await editData(cleanData);
  };

  return (
    <Fragment>
      {successMessage && (
        <div
          className="bg-[#E7F8EF] rounded-xl font-medium py-2 px-6 text-[#0E7C3A] mb-3"
          role="alert"
        >
         <p className=" text-sm">{successMessageText}</p> 
        </div>
      )}
      {errorMessage && (
        <div
          className="bg-[#FEE2E2] rounded-xl font-medium py-2 px-6 text-[#B91C1C] mb-3"
          role="alert"
        >
          <p className=" text-sm">{errorMessageText}</p>
        </div>
      )}

      <form
        className="space-y-6 md:space-y-8"
        onSubmit={handleSubmit(sendDataProfile)}
      >
        <div className="flex flex-col md:flex-row md:items-center md:justify-between md:gap-4">
          <div>
            <label className="w-full md:w-1/4 text-gray-700 font-bold text-base">
              Nombres
            </label>
            <p className=" text-xs font-light text-[#757575]">
              Agrega ambos nombres
            </p>
          </div>
          <div className="w-full md:w-3/4 ">
            <input
              type="text"
              className="w-full rounded-xl border border-gray-300 px-4 py-2 focus:outline-none focus:ring-2 focus:ring-blue-400"
              placeholder="Ejemplo: Oscar Andrés"
              {...register("first_name")}
            />
            <p className="text-sm mt-2 font-semibold text-red text-left">
              {errors?.first_name?.message}
            </p>
          </div>
        </div>

        <div className="flex flex-col md:flex-row md:items-center md:justify-between md:gap-4">
          <div>
            <label className="w-full md:w-1/4 text-gray-700 font-bold text-base">
              Apellidos
            </label>
            <p className=" text-xs font-light text-[#757575]">
              Agrega ambos apellidos
            </p>
          </div>
          <div className="w-full md:w-3/4 ">
            <input
              type="text"
              className="w-full rounded-xl border border-gray-300 px-4 py-2 focus:outline-none focus:ring-2 focus:ring-blue-400"
              placeholder="Ejemplo: Barrientos García"
              {...register("last_name")}
            />
            <p className="text-sm mt-2 font-semibold text-red text-left">
              {errors?.last_name?.message}
            </p>
          </div>
        </div>

        <div className="flex flex-col md:flex-row md:items-center md:justify-between md:gap-4">
          <div>
            <label className="w-full md:w-1/4 text-gray-700 font-bold text-base">
              Correo Electrónico
            </label>
            <p className=" text-xs font-light text-[#757575]">
              Para que tengamos mejor comunicación
            </p>
          </div>
          <input
            type="email"
            disabled
            className="w-full md:w-3/4 rounded-xl border border-gray-300 bg-gray-100 px-4 py-2"
            placeholder="Ejemplo: tucorreo@gmail.com"
            {...register("email")}
          />
        </div>

        <div className="flex flex-col md:flex-row md:items-center md:justify-between md:gap-4">
          <div>
            <label className="w-full md:w-1/4 text-gray-700 font-bold text-base">
              Fecha de nacimiento
            </label>
            <p className=" text-xs font-light text-[#757575]">
              Para que tengamos mejor comunicación
            </p>
          </div>
          <div className="w-full md:w-3/4 ">
            <input
              type="date"
              className="w-full rounded-xl border border-gray-300 px-4 py-2 focus:outline-none focus:ring-2 focus:ring-blue-400"
              {...register("birth_date")}
            />
            <p className="text-sm mt-2 font-semibold text-red text-left">
              {errors?.birth_date?.message}
            </p>
          </div>
        </div>

        <div className="flex flex-col md:flex-row md:items-center md:justify-between md:gap-4">
          <div>
            <label className="w-full md:w-1/4 text-gray-700 font-bold text-base">
              Género
            </label>
            <p className=" text-xs font-light text-[#757575]">
              Información adicional para conocerte mejor
            </p>
          </div>
          <div className="w-full md:w-3/4">
            <select
              className="w-full rounded-xl border border-gray-300 px-4 py-3 focus:outline-none focus:ring-2 focus:ring-blue-400 text-sm"
              {...register("gender")}
            >
              <option value="" disabled>
                Selecciona tu género
              </option>
              <option value="M">Masculino</option>
              <option value="F">Femenino</option>
            </select>
            <p className="text-sm mt-2 font-semibold text-red text-left">
              {errors?.gender?.message}
            </p>
          </div>
        </div>

        <div className="w-full flex justify-end items-center">
          <Button
            type="submit"
            className="w-full lg:w-auto mt-8 ml-auto font-semibold py-3 px-4 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-400"
          >
            Actualizar mis datos
          </Button>
        </div>
      </form>
    </Fragment>
  );
};
export default ProfileForm;
